module.exports = __webpack_public_path__ + "static/media/momentiveaminofunctionalfluid.ede313e9.png";